module.exports = __webpack_public_path__ + "assets/merriweather-regular.f3db3e138ef76ec7a0afc944650734dc.woff2";